import React, {useEffect, useState} from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';

const EmptyScreen = (props) => {
    return (
        <Row className='mt-5' style={{ textAlign:'center', display:'flex', justifyContent:'center'}}>
            <p className='mt-5' style={{fontSize:22, opacity:0.6}}>{props.children}</p>
        </Row>
    );
};
  
export default EmptyScreen;
  